import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Switch, Route, Link, withRouter, Redirect } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { NavItem } from 'react-bootstrap';
import EmployeeCountPage from './EmployeeCountPage';
import AnnualRevenuePage from './AnnualRevenuePage';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import CRMInstanceName from '../../../../components/crm-instance-name';

function AccountSizePage(props) {
  const { organization, location } = props;
  const isDemo = organization && organization.is_demo;

  const orgType = organization && organization.type;
  let accountObjectName = 'Account';
  if (orgType === 'hubspot') {
    accountObjectName = 'company';
  }

  return (
    <div>
      <Helmet title="Account Size | Setup" />
      <div className="container">
        {!isDemo &&
          <div className="well well-sm">
            <div>
              <p>
                Select custom fields from your <code>Account</code> object in your <CRMInstanceName /> instance for Annual Revenue and Employee Count account size calculations.
              </p>
              <p>
                If you cannot find the field(s) you are looking for, you can also <Link to={`/setup/sync-settings/${accountObjectName}`}>add more custom fields to the sync</Link>.
              </p>
            </div>
          </div>
        }
        {isDemo &&
          <div className="alert alert-warning">
            This is a demo organization, please switch back to the original organization to change the settings.
          </div>
        }
        {!isDemo &&
          <div>
            <ul className="nav nav-tabs">
              <LinkContainer exact to="/setup/account-size/annual-revenue">
                <NavItem>Annual Revenue</NavItem>
              </LinkContainer>
              <LinkContainer exact to="/setup/account-size/employee-count">
                <NavItem>Employee Count</NavItem>
              </LinkContainer>
            </ul>
            <p />
          </div>
        }
      </div>
      {!isDemo &&
        <Switch>
          <Route path="/setup/account-size/employee-count" component={EmployeeCountPage} />
          <Route path="/setup/account-size/annual-revenue" component={AnnualRevenuePage} />
          {(location.pathname === '/setup/account-size' && <Redirect to="/setup/account-size/annual-revenue" />)}
        </Switch>
      }
    </div>
  );
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

AccountSizePage.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  organization: PropTypes.shape({}).isRequired,
};

AccountSizePage.contextTypes = {
};

export default connect(mapStateToProps)(withRouter(AccountSizePage));
